<template>
  <article class="content-container">
    <HeadingWithIcon
      :icon="setupIcon"
      iconAlt="ตั้งค่า"
      :title="$t('tutorial.title')" />
    <div class="setup-container">
      <article class="content-group">
        <h4 class="content-title">1. {{$t('tutorial.step1.title')}}</h4>
        <div class="keys-container">
          <InputCopy
            elementId="server"
            title="Server"
            :value="streamServer" />
          <InputCopy
            elementId="key"
            title="Stream Key"
            :value="streamKey" />
        </div>
      </article>
      <article class="content-group">
        <h4 class="content-title">2. {{$t('tutorial.step2.title')}}</h4>
        <p class="content-description">{{$t('tutorial.step2.helpText')}}</p>
        <img
          class="content-image"
          src="./images/setup.png"
          alt="ภาพตัวอย่างการวาง Server และ Stream Key ในโปรแกรม OBS Studio">
      </article>
      <article class="content-group">
        <h4 class="content-title">3. {{$t('tutorial.step3.title')}}</h4>
        <p class="content-description">{{$t('tutorial.step3.helpText')}}</p>
        <img
          class="content-image"
          src="./images/startStreaming.png"
          alt="ภาพตัวอย่างการไลฟ์ด้วยโปรแกรม OBS Studio">
      </article>
    </div>
  </article>
</template>

<script>
import HeadingWithIcon from '@/components/HeadingWithIcon.vue';
import InputCopy from '@/components/InputCopy.vue';

const setupIcon = require('@/assets/images/icons/digital-book.svg');

export default {
  data() {
    return {
      setupIcon,
    };
  },
  computed: {
    streamServer() {
      return this.$store.state.stream.server;
    },
    streamKey() {
      return this.$store.state.stream.streamkey;
    },
  },
  components: {
    HeadingWithIcon,
    InputCopy,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.setup-container {
  padding: $spacer 0;
  .keys-container {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    .form-group {
      flex: 0 0 48%;
    }
  }
}

@media screen and (max-width: 660px) {
  .setup-container {
    .keys-container {
      flex-flow: column;
      .form-group {
        flex: 0 0 100%;
      }
    }
  }
}
</style>
